function selectManufacturer(field) {
    const formId = field.getAttribute('data-for-servicing-manufacturer-form');
    let forms = [];

    if (formId) {
        forms = [...document.querySelectorAll(`[data-servicing-manufacturer-form-id=${formId}]`)];
    }

    forms.filter(form => form.getAttribute('data-manufacturer') != field.value).forEach(form => form.classList.add('hidden'));

    forms.find(form => form.getAttribute('data-manufacturer') == field.value).classList.remove('hidden');
}

function init() {
    const selectFields = document.querySelectorAll('.js_servicingManufacturerSelect');

    selectFields.forEach(field => field.addEventListener('change', e => selectManufacturer(field)));
}

$(document).ready(init);
